import {
  useMfaServiceMfaLockoutsDestroy,
  useMfaServiceMfaLockoutsListKey
} from '@organization/api/queries'
import { showApiErrors } from '@shared/utils'
import { useQueryClient } from '@tanstack/react-query'
import { App, Modal } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { CommonProps } from './types'

export const DeleteLockout = ({
  data,
  open,
  onSuccess,
  onCancel
}: CommonProps) => {
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal()
  const { message } = App.useApp()
  const queryClient = useQueryClient()

  const { mutateAsync: deleteMutation } = useMfaServiceMfaLockoutsDestroy({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useMfaServiceMfaLockoutsListKey]
      })

      message.success(t('removed_successfully'))

      onSuccess()
    },
    onError: (error) => showApiErrors(error)
  })

  useEffect(() => {
    const id = data?.id
    if (!id) return

    const { destroy } = modal.confirm({
      title: t('delete_confirm'),
      content: t('delete_confirm_description_lockout'),
      okText: t('delete'),
      cancelText: t('cancel'),
      okType: 'danger',
      onOk: () => deleteMutation({ id }),
      open,
      onCancel
    })

    return destroy
  }, [data, deleteMutation, modal, onCancel, open, t])

  return contextHolder
}
